type Props = {};

const ArrowUp = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7.19999C12.7 7.19999 13.4 7.46999 13.93 7.99999L20.45 14.52C20.74 14.81 20.74 15.29 20.45 15.58C20.16 15.87 19.68 15.87 19.39 15.58L12.87 9.05999C12.39 8.57999 11.61 8.57999 11.13 9.05999L4.60998 15.58C4.31998 15.87 3.83998 15.87 3.54998 15.58C3.25998 15.29 3.25998 14.81 3.54998 14.52L10.07 7.99999C10.6 7.46999 11.3 7.19999 12 7.19999Z"
        fill="#292D32"
      />
    </svg>
  );
};

export default ArrowUp;
